import React from "react";

function TitansHousingVideo() {
  return (
    <>
      <div className="titansVideoBanner">
          <img src="./s3/videoplay_icon.svg"
            alt="Play Titans Housing Video"
            className="pt-5"
            data-bs-toggle="modal" data-bs-target="#videoModal"
          />
      </div>
        {/* Modal */}
        <div className="modal fade" id="videoModal"
          tabIndex="-1" aria-labelledby="videoModalLabel"
          aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <video className="object-fit-cover" controls>
                <source src="./s3/titans_housing.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
    </>
  );
}

export default TitansHousingVideo;
